import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { AdmissionValorization } from "src/app/model/admission";
import { DocumentationItem } from "src/app/model/documentation-item";
import {
  MedicalAppointmentAudintingSearchItem,
  MedicalAppointmentAudintingType,
} from "src/app/model/medical-appointment-auditing/medical-appointment-auditing-search-item";
import { PatientView } from "src/app/model/patient";
import { Reservation, ReservationInfo } from "src/app/model/reservation";
import { Valorization } from "src/app/model/valorization";
import { ValorizationEdit } from "src/app/model/valorization-edit";
import { ValorizationItemAmount } from "src/app/model/valorization-item";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { MedicalAppointmentAuditingService } from "src/app/services/medical-appointment-auditing/medical-appointment-auditing.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { PatientService } from "src/app/services/patient.service";
import { ReservationService } from "src/app/services/reservation.service";
import { ValorizationService } from "src/app/services/valorization/valorization.service";
import { ReservationRescheduleWizardService } from "src/app/services/wizard/reservation/reservation-reschedule.wizard.service";
import {
  ObservationDialogComponent,
  ObservationDialogEditResponse,
} from "../../dialogs/observation-dialog/observation-dialog.component";
import { MedicalAppointmentAuditingOtherDialogComponent } from "../medical-appointment-auditing-other-dialog/medical-appointment-auditing-other-dialog.component";
import { MedicalAppointmentOrderAuditing } from "src/app/model/medical-appointment-auditing/medical-appointment-order-auditing";
import {
  MedicalAppointmentOrderAuditingUpdate,
  MedicalAppointmentPlanAuditingUpdate,
} from "src/app/model/medical-appointment-auditing/medical-appointment-order-auditing-update";
import { LogViewDialogComponent } from "../../dialogs/log-view/log-view-dialog.component";
import { MedicalAppointmenObservationDialogComponent } from "../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";

export interface MedicalAppointmentAuditingControlDialogComponentRequest {
  appointment: MedicalAppointmentAudintingSearchItem;
  canEditOthers: boolean;
}

@Component({
  selector: "app-medical-appointment-auditing-control-dialog",
  templateUrl: "./medical-appointment-auditing-control-dialog.component.html",
  styleUrls: ["./medical-appointment-auditing-control-dialog.component.css"],
})
export class MedicalAppointmentAuditingControlDialogComponent
  implements OnInit
{
  patient: PatientView;
  valorizationEdit: ValorizationEdit;

  displayAllValorizationItemsColumns = [
    "practiceName",
    "quantity",
    "feeAmount",
    "feeCoverage",
    "rightsAmount",
    "rightsCoverage",
    "moduleAmount",
    "moduleCoverage",
    "supplieAmount",
    "supplieCoverage",
    "assuranceAmount",
    "totalAmount",
    "patientAmountWithTax",
    "entityAmountWithTax",
  ];

  displayNoAmountValorizationItemsColumns = [
    "practiceName",
    "quantity",
    "feeCoverage",
    "rightsCoverage",
    "moduleCoverage",
    "supplieCoverage",
  ];

  displayDocumentationItemsColumns = ["name", "carryPatient", "info", "star"];
  loadingAuditPatient = false;
  loadingAuditProcedure = false;
  loadingAuditDocumentation = false;
  loadingAuditMedicalRecord = false;
  loadingReferredToCallCenter = false;
  existOtherAppointments: boolean = false;
  otherAppointments: MedicalAppointmentAudintingSearchItem[] = [];
  orderAuditing: MedicalAppointmentOrderAuditing;
  orderAuditingEdited: MedicalAppointmentOrderAuditingUpdate;
  planAuditingEdited: MedicalAppointmentPlanAuditingUpdate;

  laodingValorization: boolean = true;
  loadingPatient: boolean = true;

  canReservationReschedule: boolean = false;
  orderId: number;
  entityId?: number;
  planId?: number;

  constructor(
    public dialogRef: MatDialogRef<MedicalAppointmentAuditingControlDialogComponent>,
    private authService: AuthService,
    private valorizationService: ValorizationService,
    private confirmDialogService: ConfirmDialogService,
    private medicalAppointmentAuditingService: MedicalAppointmentAuditingService,
    private reservationService: ReservationService,
    private notificationToastService: NotificationToastService,
    private reservationRescheduleWizardService: ReservationRescheduleWizardService,
    private patientService: PatientService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: MedicalAppointmentAuditingControlDialogComponentRequest
  ) {}

  ngOnInit() {
    this.loadInfo();
  }

  loadInfo() {
    if (this.data.canEditOthers) {
      this.medicalAppointmentAuditingService
        .getByDateAndPatient(
          new Date(this.data.appointment.Date),
          this.data.appointment.PatientId
        )
        .then((items) => {
          this.otherAppointments = items.filter(
            (item) =>
              item.MedicalAppointmentId !==
                this.data.appointment.MedicalAppointmentId &&
              !item.IsDocumentationValidated &&
              !item.IsProcedureValidated &&
              !item.IsMedicalRecordValidated &&
              !item.IsPatientDataValidated &&
              !item.IsReferredToCallCenter
          );
          this.existOtherAppointments = this.otherAppointments.length > 0;
        });
    }

    this.medicalAppointmentAuditingService
      .getOrderAuditingByOrderId(this.data.appointment.OrderId)
      .then((orderAuditing) => {
        this.orderAuditing = orderAuditing;
      });

    this.orderId = this.data.appointment.OrderId;
    this.canReservationReschedule = this.authService.canReservationReschedule();
    this.patientService
      .getPatientView(this.data.appointment.PatientId)
      .then((patient) => {
        this.loadingPatient = false;
        this.patient = patient;
      });

    this.valorizationService
      .getNewAdmissionValorization(
        this.data.appointment.MedicalAppointmentId,
        null
      )
      .then((valorization: AdmissionValorization) => {
        this.valorizationEdit = valorization.ValorizationEdit;
        this.entityId = this.valorizationEdit.ValorizationAmount.Entity.Id;
        this.planId = this.valorizationEdit.ValorizationAmount.Plan.Id;

        this.laodingValorization = false;
      });
  }

  get valorizationItems() {
    return this.valorizationEdit &&
      this.valorizationEdit.ValorizationAmount &&
      this.valorizationEdit.ValorizationAmount.ValorizationItemsAmount
      ? this.valorizationEdit.ValorizationAmount.ValorizationItemsAmount
      : [];
  }

  get documentationItems() {
    return this.valorizationEdit && this.valorizationEdit.DocumentationItems
      ? this.valorizationEdit.DocumentationItems
      : [];
  }

  getName(item: ValorizationItemAmount): string {
    return (
      "(" +
      item.ValorizationItem.MedicalAppointmentProcedure.Code +
      "/" +
      item.Code +
      ") - " +
      (item.ValorizationItem.MedicalAppointmentProcedure
        .PracticeRegionAditionalId
        ? item.ValorizationItem.MedicalAppointmentProcedure
            .PracticeRegionAditionalName
        : item.ValorizationItem.MedicalAppointmentProcedure.PracticeRegionName)
    );
  }

  displayQuantity(item: ValorizationItemAmount): number {
    return item.ValorizationItem.MedicalAppointmentProcedure.Quantity;
  }

  displayFeeAmount(item: ValorizationItemAmount): string {
    return this.toFixed(item.FeeAmount);
  }

  displayFeeCoverage(item: ValorizationItemAmount): string {
    return this.toFixed(item.FeeCoverage);
  }

  displayRightsAmount(item: ValorizationItemAmount): string {
    return this.toFixed(item.RightsAmount);
  }

  displayRightsCoverage(item: ValorizationItemAmount): string {
    return this.toFixed(item.RightsCoverage);
  }

  displayModuleAmount(item: ValorizationItemAmount): string {
    return this.toFixed(item.ModuleAmount);
  }

  displayModuleCoverage(item: ValorizationItemAmount): string {
    return this.toFixed(item.ModuleCoverage);
  }

  displaySupplieAmount(item: ValorizationItemAmount): string {
    return this.toFixed(item.SupplieAmount);
  }

  displaySupplieCoverage(item: ValorizationItemAmount): string {
    return this.toFixed(item.SupplieCoverage);
  }

  displayAssuranceAmount(item: ValorizationItemAmount): string {
    return this.toFixed(item.ValorizationItem.AssuranceAmount);
  }

  displayTotalAmount(item: ValorizationItemAmount): string {
    return this.toFixed(
      item.ValorizationItem.MedicalAppointmentProcedure.Quantity *
        item.TotalAmount
    );
  }

  displayPatientAmountWithTax(item: ValorizationItemAmount): string {
    return this.toFixed(
      item.ValorizationItem.MedicalAppointmentProcedure.Quantity *
        (item.PatientAmount + item.PatientTaxAmount)
    );
  }

  displayEntityAmountWithTax(item: ValorizationItemAmount): string {
    return this.toFixed(
      item.ValorizationItem.MedicalAppointmentProcedure.Quantity *
        (item.EntityAmount + item.EntityTaxAmount)
    );
  }

  displayDocumentName(item: DocumentationItem): string {
    return item.Name;
  }

  displayDocumentDescription(item: DocumentationItem): string {
    return item.Description;
  }

  displayDocumentCarryPatient(item: DocumentationItem): string {
    return item.CarryPatient ? "Si" : "No";
  }

  displayDocumentInfo(item: DocumentationItem): string {
    return item.Info;
  }

  toFixed(number): string {
    if (number) {
      return number.toFixed(2);
    } else {
      return "";
    }
  }

  get seeAmounts() {
    return this.authService.seeAdmissionValorizationAmount();
  }

  async planChanged(planId?: number) {
    if (this.planId !== planId) {
      this.laodingValorization = true;
      this.valorizationService
        .getNewAdmissionValorization(
          this.data.appointment.MedicalAppointmentId,
          null,
          planId
        )
        .then((valorization: AdmissionValorization) => {
          this.valorizationEdit = valorization.ValorizationEdit;
          this.entityId = this.valorizationEdit.ValorizationAmount.Entity.Id;
          this.planId = this.valorizationEdit.ValorizationAmount.Plan.Id;

          this.planAuditingEdited = {
            PlanId: planId,
            OrderId: this.data.appointment.OrderId,
          };
          this.laodingValorization = false;
        })
        .catch((err) => {
          this.laodingValorization = false;
          this.notificationToastService.error(
            "Error al cargar la valorización: " + err.error,
            "Valorización"
          );
        });
    }
  }

  async onPatientAuditChange(isValidated: boolean) {
    this.loadingAuditPatient = true;
    await this.medicalAppointmentAuditingService.audit(
      MedicalAppointmentAudintingType.validadoDatoPaciente,
      this.data.appointment.MedicalAppointmentId,
      isValidated
    );

    this.data.appointment.IsPatientDataValidated = isValidated;

    this.loadingAuditPatient = false;
  }

  async auditReferredToCallCenterValidated() {
    const dialogRef = this.dialog.open(ObservationDialogComponent, {
      width: "50%",
      data: {
        text: "",
        textMenu: "Observaciones",
        noRequired: true,
      },
    });

    dialogRef
      .afterClosed()
      .subscribe(async (response: ObservationDialogEditResponse) => {
        if (response) {
          this.loadingReferredToCallCenter = true;
          await this.medicalAppointmentAuditingService.audit(
            MedicalAppointmentAudintingType.derivadoCallCenter,
            this.data.appointment.MedicalAppointmentId,
            !this.data.appointment.IsReferredToCallCenter,
            response.text
          );

          this.loadingReferredToCallCenter = false;
          this.data.appointment.IsReferredToCallCenter =
            !this.data.appointment.IsReferredToCallCenter;
        }
      });
  }

  openMedicalAppointmentObservationDialog(): void {
    const dialogRef = this.dialog.open(
      MedicalAppointmenObservationDialogComponent,
      {
        width: "50%",
        data: {
          medicalAppointmentId: this.data.appointment.MedicalAppointmentId,
        },
      }
    );
  }

  openLogViewDialog(): void {
    const dialogRef = this.dialog.open(LogViewDialogComponent, {
      width: "50%",
      data: this.data.appointment.MedicalAppointmentId,
    });
  }

  async auditProcedures() {
    this.loadingAuditProcedure = true;
    await this.medicalAppointmentAuditingService.audit(
      MedicalAppointmentAudintingType.validadoPractica,
      this.data.appointment.MedicalAppointmentId,
      !this.data.appointment.IsProcedureValidated
    );

    this.loadingAuditProcedure = false;
    this.data.appointment.IsProcedureValidated =
      !this.data.appointment.IsProcedureValidated;
  }

  async auditDocumentation() {
    this.loadingAuditDocumentation = true;
    await this.medicalAppointmentAuditingService.audit(
      MedicalAppointmentAudintingType.validadoDocumentacion,
      this.data.appointment.MedicalAppointmentId,
      !this.data.appointment.IsDocumentationValidated
    );

    this.loadingAuditDocumentation = false;
    this.data.appointment.IsDocumentationValidated =
      !this.data.appointment.IsDocumentationValidated;
  }

  async auditMedicalRecordValidated() {
    this.loadingAuditMedicalRecord = true;
    await this.medicalAppointmentAuditingService.audit(
      MedicalAppointmentAudintingType.validadoHce,
      this.data.appointment.MedicalAppointmentId,
      !this.data.appointment.IsMedicalRecordValidated
    );

    this.loadingAuditMedicalRecord = false;
    this.data.appointment.IsMedicalRecordValidated =
      !this.data.appointment.IsMedicalRecordValidated;
  }

  reservationRescheduling() {
    this.getAllPosibleRescheduleReservation(
      this.data.appointment.MedicalAppointmentId
    )
      .then((reservationInfo) => {
        this.dialogRef.close();
        this.reservationRescheduleWizardService.setReservationAndStartWizard(
          new Reservation(reservationInfo),
          "medical-appointment-auditing-search"
        );
      })
      .catch((err) => {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Reprogramación"
        );
      });
  }

  private getAllPosibleRescheduleReservation(
    medicalAppointmentId: number
  ): Promise<ReservationInfo> {
    const posible =
      this.reservationService.getAllPosibleRescheduleReservation(
        medicalAppointmentId
      );
    const confirmDialogService = this.confirmDialogService;
    const promise = new Promise<ReservationInfo>(function (resolve, reject) {
      posible
        .then((result: ReservationInfo) => {
          if (result.MedicalAppointmentIdsToCancel.length > 1) {
            confirmDialogService
              .confirm(
                "Reprogramación",
                "Existen turnos para el mismo día y Centro del Turno seleccionado, ¿desea reprogramarlos de forma conjunta?",
                "Sí",
                "No"
              )
              .subscribe((value) => {
                if (!value) {
                  for (
                    let i = result.ServiceReservations.length - 1;
                    i > -1;
                    i--
                  ) {
                    if (
                      result.ServiceReservations[i].MedicalAppointmentId !==
                      medicalAppointmentId
                    ) {
                      result.ServiceReservations.splice(i, 1);
                      result.MedicalAppointmentIdsToCancel.splice(i, 1);
                    }
                  }
                  resolve(result);
                } else {
                  resolve(result);
                }
              });
          } else {
            resolve(result);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  async saveAndClose() {
    if (this.orderAuditingEdited || this.planAuditingEdited) {
      try {
        await this.medicalAppointmentAuditingService.updateOrder(
          this.orderAuditingEdited,
          this.planAuditingEdited
        );
      } catch (err) {
        this.notificationToastService.error(
          "Error al actualizar: " + err.error,
          "Actualización de Orden"
        );
        return;
      }
    }
    this.dialogRef.close();
  }

  orderChanged(order: MedicalAppointmentOrderAuditingUpdate) {
    this.orderAuditingEdited = order;
  }

  auditOther(): void {
    const dialogRef = this.dialog.open(
      MedicalAppointmentAuditingOtherDialogComponent,
      {
        width: "50%",
        data: this.otherAppointments,
      }
    );

    dialogRef
      .afterClosed()
      .subscribe(async (item: MedicalAppointmentAudintingSearchItem) => {
        if (item) {
          this.dialog.open(MedicalAppointmentAuditingControlDialogComponent, {
            width: "100vw", // Ocupa el ancho total de la pantalla
            height: "100vh", // Ocupa el alto total de la pantalla
            maxWidth: "100vw",
            maxHeight: "100vh",
            panelClass: "full-screen-dialog", // Clase CSS para más ajustes
            data: {
              appointment: item,
              canEditOthers: false,
            },
          });
        }
      });
  }
}
